import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CreateSupplierInvoiceService {

    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
    ) {

    }
}
